import { ReactNode } from 'react'
import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'
import Users, { UsersShortDescriptor } from './Users'
import Audience, { AudienceShortDescriptor } from './Audience'
import Divider from 'Shared/components/Divider'

// eslint-disable-next-line react/prop-types
function ShortDescriptor({
  dashboardScope,
  groups,
}: {
  dashboardScope: ReactNode
  groups: {
    name: string
  }[]
}) {
    return <div>
        <UsersShortDescriptor dashboardScope={dashboardScope} groups={groups} />
        <AudienceShortDescriptor />
    </div>
}

export default () => {
  const act = useAct()
  const { id, groups, scope, search, searchId } = useSel((s) => s.dashboard)
  const complete = searchId !== null && search !== null
  
  function save() {
    return act.builder.save('access-and-audience').then(() => {
        act.builder.closeEditor()
    })
  }

  return (
    <Step
      name="Dashboard Access & Audience"
      editor="access-and-audience"
      editable={true}
      complete={complete}
      shortDescriptor={<ShortDescriptor dashboardScope={scope} groups={groups} />}
      save={save}
      showSave={true}
      showDiscard={true}
      showClose={false}
    >
        <h3 className="no-margin">Who can use this Dashboard?</h3>
        <Users />
        <Divider />
        <h3 className="no-margin margin-bottom">Which members are visible in the dashboard?</h3>
        <Audience />
    </Step>
  )
}
